import React, { useEffect } from 'react';
import LaunchIndividual from './launch-individual';
import LaunchSelection from './launch-selection';
import LaunchUpload from './launch-upload';

function LaunchContent() {
  const [showSelection, setShowSelection] = React.useState(true);
  const [showIndividual, setShowIndividual] = React.useState(false);
  const [showUpload, setShowUpload] = React.useState(false);

  const selectionMade = (selection) => {
    if (selection === 'individual') {
      setShowSelection(false);
      setShowIndividual(true);
      setShowUpload(false);
    } else if (selection === 'csv') {
      setShowSelection(false);
      setShowIndividual(false);
      setShowUpload(true);
    } else if (selection === 'back') {
      setShowSelection(true);
      setShowIndividual(false);
      setShowUpload(false);
    }
  };

  useEffect(() => {
    setShowIndividual(false);
    setShowSelection(true);
  }, []);

  return showSelection ? (
    <LaunchSelection selectionMade={selectionMade} />
  ) : showIndividual ? (
    <LaunchIndividual selectionMade={selectionMade} />
  ) : showUpload ? (
    <LaunchUpload selectionMade={selectionMade} />
  ) : (
    <></>
  );
}

export default LaunchContent;
